<template>
    <article>
        <div>
            <h2 role="doc-subtitle">Lists to live by</h2>
            <p>Find helpful checklists for<br> recurring routines in all areas of your life.</p>
            <br>
            <p v-show="$route.name=='Home'">
                <router-link :to="{name: 'AllChecklists'}">
                    <b>See all checklists</b>
                </router-link>
            </p>
        </div>
        <div>
            <img :src="image" >
        </div>
    </article>
</template>

<script>
export default {
    name: 'LandingHeader',
    data: function(){
        return {
            image: require('@/assets/images/checklist.svg')
        }
    }
}
</script>